import Union from '../assets/Union'
import Link from '../assets/Link'
import { SortableHandle } from 'react-sortable-hoc'

const DragHandle = SortableHandle(() => (
  <span className='category-manager_union-icon'>
    <Union />
  </span>)
)

const Category = (props) => (
  <li className={`category-manager_category-overview qa-category-${props.category.id}`}>
    <div className='category-manager_category-overview-left'>
      <DragHandle />
      <span className='category-manager_category-title'>{props.category.title}</span>
    </div>
    <div className='category-manager_category-overview-right' >
      <a href={`${props.editCategoryLink}?id=${props.category.id}`}>Edit</a>
      <a href={props.category.url}
        target='_blank'
        className='category-manager_link-icon'>
        <Link />
      </a>
    </div>
  </li>
)

export default Category
